{
    "NODE_ENV": "development",
    "BASE_URL": "/",
    "SOCKET_PORT": "3000",
    "CHART_X_LIMIT": 30
}
